import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'optin_select.title1',
    defaultMessage: 'Let’s keep in touch',
  },
  description: {
    id: 'optin_select.text1',
    defaultMessage:
      "I confirm I have read Certilogo's {privacy} and {brand}'s {brandPrivacy} and I freely provide my consent to the processing of my personal data by Certilogo and/or by {brand} for the following purposes:",
  },
  marketing: {
    id: 'optin_select.text2',
    defaultMessage: 'The promotion of Certilogo products and services by Certilogo and by {brand}',
  },
  marketingClg: {
    id: 'optin_select.text3',
    defaultMessage: 'Certilogo',
  },
  profiling: {
    id: 'optin_select.text5',
    defaultMessage:
      'The profiling of my preferences in order to receive promotional communications in line with my interests by Certilogo and by {brand}',
  },
  profilingClg: {
    id: 'optin_select.text6',
    defaultMessage: 'Certilogo',
  },
  selectAll: {
    id: 'optin_select.text8',
    defaultMessage: 'Select all',
  },
  deselectAll: {
    id: 'optin_deselect.text1',
    defaultMessage: 'Deselect all',
  },
  button: {
    id: 'optin.button1',
    defaultMessage: 'Continue',
  },
  terms: {
    id: 'terms',
    defaultMessage: 'Terms & Conditions',
  },
  privacy: {
    id: 'privacy',
    defaultMessage: 'Privacy Policy',
  },
  privacyBrands: {
    id: 'certilogo.privacy-brands',
    defaultMessage:
      'TITOLARE E RESPONSABILE DEL TRATTAMENTO DEI DATI PERSONALI (TERZE PARTI)↵========================================================================↵↵[ASRV](https://asrv.co/pages/privacy-policy)  ↵  ↵[Ballantyne](https://shop.ballantyne.it/en-US/policy/CondPrv)  ↵  ↵[Blumarine](https://www.blumarine.com/it/privacy)  ↵  ↵[Buscemi](https://www.buscemi.com/privacy-policy)  ↵  ↵[C.P. Company](https://www.cpcompany.com/en/privacy-policy)  ↵  ↵[Campagnolo/Fulcrum](https://www.campagnolo.com/WW/en/store/privacy_policy)  ↵  ↵[Chopard](https://www.chopard.com/intl/legal-privacy-policy/)  ↵  ↵[Ciesse Piumini](https://www.ciessepiumini.com/it_it/privacy)  ↵  ↵[Colmar](https://www.colmar.it/en-gb/customercare/docs/privacy)  ↵  ↵[Colmar Originals](https://www.colmar.it/en-gb/customercare/docs/privacy)  ↵  ↵[Diego M](https://www.diegom.it/diegoemme/trattamento-dei-dati-e-condizioni-di-utilizzo-del-sito/)  ↵  ↵[Diesel](https://uk.diesel.com/en/cms/legal/informativa-privacy.html)  ↵  ↵[GCDS](https://gcds.it/pages/policies)  ↵  ↵[Giorgio Armani](https://www.armani.com/us/Help/LegalArea/PrivacyPolicy)  ↵  ↵[Giuseppe Zanotti Design](https://www.giuseppezanotti.com/it/info/company/privacy-policy)  ↵  ↵[Heron Preston](https://authenticator-clientimages.s3.amazonaws.com/ngg/heron-preston/Privacy/Privacy_Policy_HeronPreston.pdf)  ↵  ↵[Hyperion](https://www.home.sandvik/en/about-this-site/privacy/)  ↵  ↵[KIRIN PEGGY GOU](https://authenticator-clientimages.s3.amazonaws.com/ngg/kirin/privacy/Privacy_Policy_KirinPeggyGou.pdf)  ↵  ↵[MBT](https://uk.mbt.com/privacy-policy/)  ↵  ↵[Marcelo Burlon](https://authenticator-clientimages.s3.amazonaws.com/ngg/marcelo-burlon/privacy/Privacy_Policy_MarceloBurlon.pdf)  ↵  ↵[Moschino](https://www.moschino.com/gb/Help/LegalArea/PrivacyPolicy)  ↵  ↵[Nobis](https://eu.nobis.com/pages/privacy-statement)  ↵  ↵[OPENING CEREMONY](https://authenticator-clientimages.s3.amazonaws.com/ngg/opening-ceremony/privacy/Privacy_Policy_OCItaly.pdf)  ↵  ↵[Off-White](../privacy-off-white/)  ↵  ↵[Palm Angels](https://authenticator-clientimages.s3.amazonaws.com/ngg/palm-angels/privacy/Privacy_Policy_Palm_Angels.pdf)  ↵  ↵[Parajumpers](https://www.parajumpers.it/it-en/legal-area/legal-area.html#tab3)  ↵  ↵[Pinko](https://www.pinko.com/en-it/customercare/privacy-policy.html)  ↵  ↵[Save The Duck](https://www.savetheduck.it/it_en/cgv/)  ↵  ↵[Stone Island](../privacy-stone-island/)  ↵  ↵[Versace](https://www.versace.com/en/about-us/privacy-policy.html)  ↵  ↵[iXOOST](https://ixoost.it/en/privacy-policy/)',
  },
});
